import React, { useState, useEffect } from 'react';
import { useHistory } from "react-router-dom";
import Flag from 'react-flagkit';
import moment from "moment";
import Carousel from 'react-multi-carousel';
import { NotificationManager } from "react-notifications";
import VisibilityIcon from "@material-ui/icons/Visibility";
import { useLazyQuery, useMutation } from '@apollo/client';
import CalendarTodayIcon from "@material-ui/icons/CalendarToday";

import { ALL_MY_COACH, CURRENT_USER_INFO } from '../../GraphQL/Queries';
import { ADD_NEW_EVENT, PARTICIPANT_ATTEND_CHANGE } from '../../GraphQL/Mutations';
import { clientWellness } from "../../App";
import { ContentCoachesHome, useStyles } from './CoachesHomeContainer.styled';
import 'react-multi-carousel/lib/styles.css';
import { getFile } from "../../services/FileManager";
import coachPhoto from "../../assets/image-not-available.png";
import coachDefault from "../../assets/svg/coach-default.svg";
import { ReactComponent as SaveMood } from "../../assets/svg/save-mood.svg";
import ModalAppointment from '../../components/ModalAppointment/ModalAppointment';
import { getStateLoginComplete } from '../LayoutHome/stateLogin';
import ModalDetailMyCoach from '../../components/ModalDetailMyCoach/ModalDetailMyCoach';

const CoachesHomeContainer = () => {
    const classes = useStyles();
    const history = useHistory();
    const [userData, setUserData] = useState({});
    const [eventId, setEventId] = useState(null);
    const [openReadMoreModal, setOpenReadMoreModal] = useState(null);
    const [user] = useState(getStateLoginComplete());
    const [openAppointmentModal, setOpenAppointmentModal] = useState(null);
    const [previewImages, setPreviewImages] = useState([]);
    const [coaches, setCoaches] = useState([]);

    const responsive = {
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 3,
        },
        tablet: {
            breakpoint: { max: 1024, min: 768 },
            items: 2,
        },
        mobile: {
            breakpoint: { max: 768, min: 0 },
            items: 1,
        },
    };

    const [participantAttendChange] = useMutation(PARTICIPANT_ATTEND_CHANGE, {
        client: clientWellness,
    });

    const [addNewEvent] = useMutation(ADD_NEW_EVENT, {
        client: clientWellness,
    });

    const [runQueryAllMyCoach] = useLazyQuery(ALL_MY_COACH, {
        client: clientWellness,
        fetchPolicy: "network-only",
        onCompleted: (data) => {
            setCoaches(data.allMyCoaches);
            if (data.allMyCoaches.length > 0) {
                let images = [];
                data.allMyCoaches.map((element) => {
                    element.coverImage !== "" &&
                        getFile(element.coverImage).then((response) => {
                            if (response && response.type !== "archivo-noexistente/json") {
                                images.push({
                                    nameImage: element.coverImage,
                                    urlImage: URL.createObjectURL(response),
                                });
                                setPreviewImages([...images]);
                            }
                        });
                });
            }
        },
    });

    const [runQueryUserInfo] = useLazyQuery(CURRENT_USER_INFO, {
        context: { clientName: "LinkUsers" },
        fetchPolicy: "network-only",
        onCompleted: (data) => {
            setUserData(data.currentUser);
        },
    });

    useEffect(() => {
        if (openAppointmentModal) {
            runQueryUserInfo();
        }
    }, [openAppointmentModal]);

    const handleAppointment = (item) => {
        if (item?.turnsAvailable?.length > 0) {
            setOpenAppointmentModal(item);
        }
    };

    let confirmAppointment = (item) => {
        if (
            item.cityId &&
            item.countryId &&
            item.eventCategoryId &&
            item.eventDescription &&
            item.eventName &&
            item.eventStatus &&
            item.eventType &&
            item.languageId &&
            item.startDate &&
            item.finishDate &&
            item.participantIsRequired
        ) {
            addNewEvent({
                variables: {
                    cityId: item.cityId,
                    countryId: item.countryId,
                    eventCategoryId: item.eventCategoryId,
                    eventDescription: item.eventDescription,
                    eventName: item.eventName,
                    eventStatus: item.eventStatus,
                    eventType: item.eventType,
                    eventUri: item.eventUri,
                    finishDate: item.finishDate,
                    groups: item.groups,
                    individualGuests: item.individualGuests,
                    languageId: item.languageId,
                    participantIsRequired: item.participantIsRequired,
                    participantsLimit: item.participantsLimit,
                    photoUri: item.photoUri,
                    speakers: item.speakers,
                    startDate: item.startDate,
                },
            })
                .then((response) => {
                    if (response.errors) {
                        NotificationManager.error(response.errors[0].message, "", 5000);
                    } else {
                        if (response.data.addNewEvent.idEvent) {
                            saveAccept(
                                response.data.addNewEvent.idEvent,
                                item.individualGuests
                            );
                            setEventId(response.data.addNewEvent.idEvent);
                        }
                    }
                })
                .catch((error) => {
                    const errorMessage = error.message.split("\n")[0];
                    NotificationManager.error(errorMessage, "", 5000);
                });
        } else {
            NotificationManager.warning("Missing fields", "", 5000);
        }
    };

    const saveAccept = (idEvent, userIds) => {
        participantAttendChange({
            variables: {
                eventId: idEvent,
                userId: userIds[0],
                participantAttend: "Accept",
                userChange: user.userName + "@nlsa.teleperformance.com",
            },
        }).catch((error) => {
            const errorMessage = error.message.split("\n")[0];
            NotificationManager.error(errorMessage, "", 5000);
        });
        participantAttendChange({
            variables: {
                eventId: idEvent,
                userId: userIds[1],
                participantAttend: "Accept",
                userChange: user.userName + "@nlsa.teleperformance.com",
            },
        }).catch((error) => {
            const errorMessage = error.message.split("\n")[0];
            NotificationManager.error(errorMessage, "", 5000);
        });
    };

    useEffect(() => {
        if (eventId) {
            NotificationManager.success("Event created", "", 5000);
            setOpenAppointmentModal(false);
            runQueryAllMyCoach({
                variables: {
                    searchBy: "",
                    startDate: null,
                    finishDate: null,
                },
            })
        }
    }, [eventId]);

    useEffect(() => {
        runQueryAllMyCoach({
            variables: {
                searchBy: "",
                startDate: null,
                finishDate: null,
            },
        })
    }, []);

    const handleSeeAvailabilty = (coach) => {
        history.push({
            pathname: `/MyCoachAvailability`,
            state: { coach: coach },
        });
    };

    return (
        <ContentCoachesHome>
            {coaches.length > 0 ?
                <Carousel
                    responsive={responsive}
                    swipeable={true}
                    draggable={true}
                    showDots={true}
                    customTransition="all 0.5s"
                >
                    {coaches.slice(0, 6).map((coach) => (
                        <div className='coachesHome' key={coach.idCoach}>
                            <img className='coach-home_img' src={
                                previewImages.filter(
                                    (item) => item.nameImage === coach.coverImage
                                )[0]?.urlImage || coachPhoto} alt="img coach" />
                            <div className='coach-home_vicibility' onClick={() => setOpenReadMoreModal(coach)}
                                onKeyDown={(event) => {
                                    if (event.key === 'Enter') {
                                        setOpenReadMoreModal(coach);
                                    }
                                }}
                                tabIndex={0}
                            >
                                <VisibilityIcon />
                            </div>
                            <div className='coaches-home_contentIMG'>
                                {coach.wellnessCoachesLanguages &&
                                    coach.wellnessCoachesLanguages?.length > 0 &&
                                    coach.wellnessCoachesLanguages?.map((item, index) => {
                                        return (
                                            <Flag
                                                key={item.idLanguage}
                                                className="coaches-home_img-language"
                                                country={`${item?.idLanguage === "en"
                                                    ? "US"
                                                    : item?.idLanguage.toUpperCase()
                                                    }`}
                                            />
                                        );
                                    })}
                            </div>
                            <h5 className='coaches-home_name'>{`${coach.firstName.split(' ')[0]} ${coach.lastName.split(' ')[0]}`}</h5>
                            {coach.turnsAvailable?.length > 0 && (
                                <div className='coach-home_content-date' onClick={() => handleAppointment(coach)}
                                    onKeyDown={(event) => {
                                        if (event.key === 'Enter') {
                                            handleAppointment(coach);
                                        }
                                    }}
                                    tabIndex={0}>
                                    <CalendarTodayIcon className={classes.iconCalendar} />{" "}
                                    <span className='coach-home_date'>
                                        {moment(coach.turnsAvailable[0].start).format("DD/MM/YYYY")}
                                    </span>
                                    <span className='coach-home_hour'>
                                        {moment(coach.turnsAvailable[0].start).format("hh:mm A")}
                                    </span>
                                </div>
                            )}
                            <div className='coach-home_available' onClick={() => handleSeeAvailabilty(coach)}
                                onKeyDown={(event) => {
                                    if (event.key === 'Enter') {
                                        handleSeeAvailabilty(coach);
                                    }
                                }}
                                tabIndex={0}>
                                Availability
                            </div>
                        </div>
                    ))}
                    {coaches.length < 3 && (
                        <>
                            {[...Array(Math.max(0, 3 - coaches.length))].map((el, index) => (
                                <div className='coachesHome' key={el}>
                                    <img className='coach-home_img' src={coachDefault} alt="Default Coach" />
                                </div>
                            ))}
                        </>
                    )}
                </Carousel>
                :
                <div className='coach-home_nonavailable'>
                    <SaveMood />
                    <span>
                        At this moment you don’t have coaches
                    </span>
                </div>
            }
            {openAppointmentModal && (
                <ModalAppointment
                    userData={userData}
                    confirmAppointment={confirmAppointment}
                    openAppointmentModal={openAppointmentModal}
                    setOpenAppointmentModal={setOpenAppointmentModal}
                />
            )}
            {openReadMoreModal && (
                <ModalDetailMyCoach
                    openReadMoreModal={openReadMoreModal}
                    setOpenReadMoreModal={setOpenReadMoreModal}
                />
            )}
        </ContentCoachesHome >
    )
}

export default CoachesHomeContainer;